<template>
  <div>
    <div
      v-if="isTablet()"
      class="cover-image"
      :style="{ backgroundImage: 'url(' + storeinfo.image_header + ')' }"
    ></div>
    <div class="term-and-condition-wrapper">
      <div class="welcome-wrapper">
        <img
          class="welcome-image"
          crm_at="welcome_image"
          :src="storeinfo.image_logo"
          alt=""
        />
        <div class="welcome-title" crm_at="welcome_title">
          {{ lbl.autologin.register_code.welcome }}<br />
          {{ storeinfo.businessName }}
        </div>
      </div>
      <div class="body-wrapper">
        <div class="check-box-wrapper">
          <!-- Term & Privacy -->
          <div
            v-if="isDisplayTermandPrivacy == null"
            class="checkbox icheck-primary"
            crm_at="checkbox_condition"
          >
            <input
              id="consentPDPA"
              v-model="checkCondition"
              crm_at="check_condition"
              class="checkbox_condition"
              type="checkbox"
              value="consentPDPA"
              @change="checkboxTermAndCondition"
            />
            <label
              v-if="displayTermAndCondition && displayPrivacyMessage"
              for="consentPDPA"
            >
              {{ lbl.consent.i_accept }}
              <a
                id="term"
                href=""
                class="text-underline"
                @click="handleClickLinkPDPA($event, true)"
              >
                {{ displayTermAndCondition }}
              </a>
              {{ lbl.consent.and }}
              <a
                id="privacy"
                href=""
                class="text-underline"
                @click="handleClickLinkPDPA($event, false)"
              >
                {{ displayPrivacyMessage }}
              </a>
            </label>
            <label v-else for="consentPDPA">
              {{ lbl.consent.i_accept }}
              <a
                id="term"
                href=""
                class="text-underline"
                @click="handleClickLinkPDPA($event, true)"
              >
                {{ lbl.consent.terms_and_conditions }}
              </a>
              {{ lbl.consent.and }}
              <a
                id="privacy"
                href=""
                class="text-underline"
                @click="handleClickLinkPDPA($event, false)"
              >
                {{ lbl.consent.privacypolicy }}
              </a>
            </label>
          </div>
          <div
            v-else-if="isDisplayTermandPrivacy !== false"
            class="checkbox icheck-primary"
            crm_at="checkbox_condition"
          >
            <input
              id="consentPDPA"
              v-model="checkCondition"
              crm_at="check_condition"
              class="checkbox_condition"
              type="checkbox"
              value="consentPDPA"
              @change="checkboxTermAndCondition"
            />
            <label
              v-if="displayTermAndCondition && displayPrivacyMessage"
              for="consentPDPA"
            >
              {{ lbl.consent.i_accept }}
              <a
                href=""
                class="text-underline"
                @click="handleClickLinkPDPA($event, true)"
              >
                {{ displayTermAndCondition }}
              </a>
              {{ lbl.consent.and }}
              <a
                href=""
                class="text-underline"
                @click="handleClickLinkPDPA($event, false)"
              >
                {{ displayPrivacyMessage }}
              </a>
            </label>
            <label v-else for="consentPDPA">
              {{ lbl.consent.i_accept }}
              <a
                href=""
                class="text-underline"
                @click="handleClickLinkPDPA($event, true)"
              >
                {{ lbl.consent.terms_and_conditions }}
              </a>
              {{ lbl.consent.and }}
              <a
                href=""
                class="text-underline"
                @click="handleClickLinkPDPA($event, false)"
              >
                {{ lbl.consent.privacypolicy }}
              </a>
            </label>
          </div>
          <!-- Under Custom years -->
          <div
            v-if="
              isDisplayAgeCondition !== null && isDisplayAgeCondition !== false
            "
            class="checkbox icheck-primary"
            crm_at="checkbox_condition_under_years"
            @change="checkboxUnderYears"
          >
            <input
              id="under_years"
              v-model="checkUnderYears"
              crm_at="check_under_years"
              class="checkbox_condition"
              type="checkbox"
              value="underYears"
            />
            <label for="under_years">
              {{ displayConsentAgeText }}
            </label>
          </div>
          <div
            v-if="isDisplayAgeCondition == null && !isPH"
            class="checkbox icheck-primary"
            crm_at="checkbox_condition_under_years"
            @change="checkboxUnderYears"
          >
            <input
              id="under_years"
              v-model="checkUnderYears"
              crm_at="check_under_years"
              class="checkbox_condition"
              type="checkbox"
              value="underYears"
            />
            <label for="under_years">
              {{ displayConsentAgeText }}
            </label>
          </div>
          <!-- Marketing -->
          <div
            v-if="isDisplayMarketing !== null && isDisplayMarketing !== false"
            class="checkbox icheck-primary"
            crm_at="checkbox_condition"
          >
            <input
              id="marketing_message"
              v-model="checkMarketing"
              crm_at="check_marketing_message"
              class="checkbox_condition"
              type="checkbox"
              value="marketing_message"
              @input="checkboxMarketing"
            />
            <label v-if="displayMarketingMessage" for="marketing_message">
              <a href="" class="text-underline" @click="getMarketing($event)">
                {{ displayMarketingMessage }}
              </a>
            </label>
            <label v-else for="marketing_message">
              <a href="" class="text-underline" @click="getMarketing($event)">
                {{ lbl.consent.marketing_message }}
              </a>
            </label>
          </div>
          <div
            v-else-if="isDisplayMarketing == null && !isPH"
            class="checkbox icheck-primary"
            crm_at="checkbox_condition"
          >
            <input
              id="marketing_message"
              v-model="checkMarketing"
              crm_at="check_marketing_message"
              class="checkbox_condition"
              type="checkbox"
              value="marketing_message"
              @input="checkboxMarketing"
            />
            <label for="marketing_message">
              <a href="" class="text-underline" @click="getMarketing($event)">
                {{ lbl.consent.marketing_message }}
              </a>
            </label>
          </div>
        </div>
        <button
          id="next-button"
          class="next-button"
          :class="{ disable: isDisabled }"
          :style="{
            backgroundColor: storeinfo.buttoncolor,
            border: storeinfo.buttoncolor,
            color: storeinfo.buttontextcolor,
          }"
          :disabled="isDisabled"
          @click="clicknext()"
        >
          {{ lbl.autologin.register_code.next_button }}
        </button>
      </div>

      <!-- Modal -->
      <ModalPDPA
        v-if="isPDPA"
        :modalcondition="modalcondition"
        :is-term-first="isTermFirst"
        :callback="consentPdpa"
      />
      <ModalMarketing
        v-if="isMarketing"
        :visible="isMarketing"
        :modalcondition="modalcondition"
        :callback="consentMarketing"
      />

      <SettingMarketing
        v-if="isSettingMarketing"
        :login-type="loginType"
        :modalcondition="modalcondition"
        :callback="consentSettingMarketing"
        @ChangeErrorMarketing="ChangeErrorSettingMarketing($event)"
      />
      <AlertError
        :show="showError"
        :data="dataError"
        @changeError="ChangeError($event)"
      />
    </div>
    <RegisterSuccessModal
      v-if="isRegisterSuccess"
      :is-show="isRegisterSuccess"
      :button-color="storeinfo.buttoncolor"
      :button-text-color="storeinfo.buttontextcolor"
      @registerSuccess="registerSuccess()"
    />
    <OtpCompanymodal
      v-if="isSentOtp"
      :is-sent-otp="isSentOtp"
      :params="otp_params"
      :obj-profile-info="objProfileInfo"
      :storeinfo="storeinfo"
      :login-type-list="loginTypeList"
      :result-otp.sync="verifyOTPSuccess"
      :consent-data="consentData"
      :is-use-single-user-account="isUseSingleUserAccount"
      @ChangeCloseOtp="ChangeCloseOtp($event)"
      @closePopup="isSentOtp = false"
    />
    <OtpRegisterEmail
      v-if="isSentOtpEmail"
      :is-sent-otp="isSentOtpEmail"
      :params="otp_params_email"
      :obj-profile-info="objProfileInfo"
      :reference-info="ReferenceInfo"
      :storeinfo="storeinfo"
      :success="isSuccessOTP"
      :data="dataOTP"
      @changeOTP="ChangeOTP($event)"
      @closePopup="isSentOtpEmail = false"
    />
    <FGFmodal
      :is-show="isFGFmodal"
      :btn-color="storeinfo.buttontextcolor"
      :btn-b-g-color="storeinfo.buttoncolor"
      :storename="storeinfo.businessName"
      :referral-points="dataCampaign ? dataCampaign.points + '' : null"
      :modal-handler="fgfModalHandler"
    />
  </div>
</template>

<script>
import Account from '@/helper/AccountHelper.js'
import AlertError from '@/components/Modal/AlertError'
import BzbsAuth from '@/core/Account/service/BzbsAuth.js'
import BzbsLogin from '@/core/Account/service/BzbsLogin.js'
import BzbsCompanycrm from '@/core/companycrm/BzbsCompanycrm'
import BzbsDashboard from '@/core/Home/BzbsDashboard'
import BzbsProfile from '@/core/Account/service/BzbsProfile.js'
import CommonMixin from '@/mixin/CommonMixin'
import ModalPDPA from '@/components/Modal/ModalPDPA.vue'
import ModalMarketing from '@/components/Modal/ModalMarketing.vue'
import RegisterSuccessModal from '@/components/Modal/RegisterSuccessModal.vue'
import SettingMarketing from '@/components/Modal/SettingMarketing.vue'
import ResponsiveMixin from '@/mixin/ResponsiveMixin'
import Vue from 'vue'
import _ from 'lodash'
import OtpCompanymodal from '@/components/Modal/Otpmodal.vue'
import OtpRegisterEmail from '@/components/Modal/OtpRegisterEmail.vue'
import FGFmodal from '@/components/Modal/FGFModal.vue'

export default {
  name: 'TermAndCondition',
  components: {
    ModalPDPA,
    AlertError,
    ModalMarketing,
    RegisterSuccessModal,
    SettingMarketing,
    OtpCompanymodal,
    OtpRegisterEmail,
    FGFmodal,
  },
  mixins: [CommonMixin, ResponsiveMixin],
  data() {
    return {
      isPH: false,
      selected_local:
        Account.getCacheCustom('BzbsLocale') == 'th' ? 1033 : 1054,
      isshowalert: false,
      isshowalertyear: false,
      isRegisterSuccess: false,
      isFGFmodal: false,
      errors: [],
      errors_year: [],
      haserrors: false,
      checkCondition: [],
      checkUnderYears: false,
      checkMarketing: [],
      month: [],
      year: [],
      day: [],
      selected_day: '',
      selected_month: '',
      selected_year: '',
      storeinfo: {
        image_header: '',
        image_logo: '',
        businessName: '',
      },
      showlang: true,
      isphoneerror: false,
      btn: {
        isactive: false,
      },
      isTermFirst: true,
      modalcondition: {
        ismodalShow: false,
        isshowbtn: true,
        privacypathpdf: '',
        termspathpdf: '',
        marketingpathpdf: '',
        notification: {
          email: false,
          sms: false,
          line: false,
        },
        storeinfo: {},
      },
      isSentOtp: false,
      otp_params: {
        contact_number: '',
        app_id: '',
        channel: 'update',
      },
      objProfileInfo: {},
      RegisterStoreConnections: {},
      Cuscompusr: null,
      AppId: null,
      sponsorId: null,
      IsCompany: null,
      loginType: null,
      Folder: null,
      LocalCode: null,
      termsVersion: null,
      privacyVersion: null,
      marketingVersion: null,
      dataError: null,
      showError: null,
      currenttimestamp: new Date().getTime(),
      catchdate: {
        date:
          Account.getCacheCustom(
            'catchdate_' + Account.getCacheCustom('app_id'),
          ) != null
            ? Account.getCacheCustom(
                'catchdate_' + Account.getCacheCustom('app_id'),
              ).date
            : null,
        month:
          Account.getCacheCustom(
            'catchdate_' + Account.getCacheCustom('app_id'),
          ) != null
            ? Account.getCacheCustom(
                'catchdate_' + Account.getCacheCustom('app_id'),
              ).month
            : null,
        year:
          Account.getCacheCustom(
            'catchdate_' + Account.getCacheCustom('app_id'),
          ) != null
            ? Account.getCacheCustom(
                'catchdate_' + Account.getCacheCustom('app_id'),
              ).year
            : null,
        timestamp: null,
      },
      consentparams: {
        dataprivacy: '',
        termandcondition: '',
        marketingOption: '',
        marketing: '',
      },
      isPDPA: false,
      isMarketing: false,
      isSettingMarketing: false,
      isErrorUnderYears: false,
      isErrorCondition: false,
      isReferenceRequired: false,
      isReferenceRequired2: false,
      isReference: true,
      isReference2: true,
      ReferenceCustomName: {},
      ReferenceCustomName2: {},
      refusercode: '',
      dataCampaign: '',
      isFromSigleSignOn: false,
      isDisplayTermandPrivacy: true,
      isDisplayAgeCondition: true,
      isDisplayMarketing: true,
      isRequiredTermandPrivacy: true,
      isRequiredAgeCondition: true,
      isRequiredMarketing: true,
      consentAge: 15,
      TermAndConditionEN: '',
      TermAndConditionTH: '',
      PrivacyMessageEN: '',
      PrivacyMessageTH: '',
      MarketingMessageEN: '',
      MarketingMessageTH: '',
      isUseSingleUserAccount: false,
      consentData: null,
      cus_compusr: null,
      isSentOtpEmail: false,
      otp_params_email: {
        contact_number: '',
        app_id: '',
        channel: 'update',
      },
      ReferenceInfo: null,
      ReferenceInfo2: null,
      isSuccessOTP: false,
      dataOTP: {},
      eventOtp: {},
      redirectUrl: '',
      loginTypeList: [],
      isOtpError: false,
      TermAndCondition: {},
      PrivacyPolicy: {},
      MarketingMessage: {},
    }
  },

  computed: {
    isDisabled() {
      return (
        (this.isRequiredTermandPrivacy && this.checkCondition.length === 0) ||
        (this.isRequiredAgeCondition && this.checkUnderYears === false) ||
        (this.isRequiredMarketing && this.checkMarketing.length === 0)
      )
    },
    displayConsentAgeText() {
      return this.lbl.consent.i_am_not_under_years.replace(
        '{0}',
        this.consentAge,
      )
    },
    displayTermAndCondition() {
      if (Account.getCacheCustom('BzbsLocale') == 'th') {
        return this.TermAndConditionTH ? this.TermAndConditionTH : ''
      } else {
        return this.TermAndConditionEN ? this.TermAndConditionEN : ''
      }
    },
    displayPrivacyMessage() {
      if (Account.getCacheCustom('BzbsLocale') == 'th') {
        return this.PrivacyMessageTH ? this.PrivacyMessageTH : ''
      } else {
        return this.PrivacyMessageEN ? this.PrivacyMessageEN : ''
      }
    },
    displayMarketingMessage() {
      if (Account.getCacheCustom('BzbsLocale') == 'th') {
        return this.MarketingMessageTH ? this.MarketingMessageTH : ''
      } else {
        return this.MarketingMessageEN ? this.MarketingMessageEN : ''
      }
    },
  },
  created() {
    this.handleFooter(false)
    this.checklocalStorage().then(() => {
      if (this.$route.query.single_signon) {
        this.isFromSigleSignOn = true
        this.init()
      } else {
        Account.removeCacheCustom(
          'setRegister_' + Account.getCacheCustom('app_id'),
        )
        this.handleCheckLogin(this.$route)
        this.isRegisterSuccess = false
        this.init()
      }
      this.redirectUrl = Account.getCacheCustomByAppId('redirectUriecomurl')
      var url =
        'https://ecommerce.buzzebees-uat.com' +
        '?token=' +
        Account.getCacheToken() +
        '&app_id=' +
        Account.getCacheCustom('app_id')

      console.log(url)
    })
  },
  methods: {
    isTablet() {
      if (screen.width >= 768) {
        return true
      } else {
        return false
      }
    },
    init() {
      this.isPH = Vue.bzbsConfig.businessRule.webFor.PH
      this.AppId = Account.getCacheCustom('app_id')
      var cooky = Account.getCacheCustom('cuscompusr')
      if (cooky) this.cus_compusr = JSON.parse(cooky)
      this.LocalCode =
        Account.getCacheCustom('BzbsLocale') == 'th' ? 1054 : 1033
      this.handleLanguage(true)
      if (this.$route.query.single_signon) {
        Promise.all([this.getCustomerStore(), this.dateofbird()]).then(() => {
          this.handleLoading(false)
        })
      } else {
        Promise.all([
          this.getprofileinit(),
          this.getCustomerStore(),
          this.dateofbird(),
        ]).then(() => {
          this.handleLoading(false)
        })
      }
    },
    handleLoading(value) {
      this.$store.commit('Loading', value)
    },
    checkboxTermAndCondition(e) {
      e.preventDefault()
      if (
        this.checkCondition.length &&
        this.checkCondition.find(e => e == 'consentPDPA')
      ) {
        this.consentparams.dataprivacy = this.PrivacyPolicy.Version
        this.consentparams.termandcondition = this.TermAndCondition.Version
        document.getElementById('consentPDPA').checked = true
      } else {
        this.checkCondition = []
        this.consentparams.dataprivacy = this.PrivacyPolicy.Version * -1
        this.consentparams.termandcondition = this.TermAndCondition.Version * -1
        document.getElementById('consentPDPA').checked = false
      }
    },
    checkboxMarketing(e) {
      e.preventDefault()
      if (this.checkMarketing) {
        this.modalcondition.notification = {
          email: true,
          sms: true,
          line: true,
        }
        this.consentparams.marketing = this.MarketingMessage.Version
      } else {
        this.modalcondition.notification = {
          email: false,
          sms: false,
          line: false,
        }
        this.consentparams.marketing = this.MarketingMessage.Version * -1
      }
    },
    checkboxUnderYears(e) {
      e.preventDefault()

      if (this.checkUnderYears) {
        this.isErrorUnderYears = false
      }
    },
    consentPdpa(valueFromChild) {
      this.handleLoading(true)
      this.isPDPA = false
      if (_.isEmpty(valueFromChild)) return

      this.modalcondition.ismodalShow = false
      if (valueFromChild == 'decline') {
        this.handleLoading(false)
        document.getElementById('consentPDPA').checked = false
        this.checkCondition = []
        this.consentparams.dataprivacy = this.PrivacyPolicy.Version * -1
        this.consentparams.termandcondition = this.TermAndCondition.Version * -1
        this.isErrorCondition = true
      } else if (valueFromChild == 'agree') {
        document.getElementById('consentPDPA').checked = true

        this.checkCondition.push('consentPDPA')
        this.handleLoading(false)
        this.consentparams.dataprivacy = this.PrivacyPolicy.Version
        this.consentparams.termandcondition = this.TermAndCondition.Version
        this.isErrorCondition = false
      }
    },
    consentMarketing(valueFromChild) {
      this.isMarketing = false
      this.handleLoading(true)
      if (_.isEmpty(valueFromChild)) return

      if (valueFromChild == 'decline') {
        this.handleLoading(false)
        this.checkMarketing = []
        document.getElementById('marketing_message').checked = false
        this.consentparams.marketing = this.MarketingMessage.Version * -1
        this.isSettingMarketing = false
      } else if (valueFromChild == 'agree') {
        this.handleLoading(false)
        this.isSettingMarketing = true
      }
    },
    consentSettingMarketing(valueFromChild) {
      this.handleLoading(true)
      this.isSettingMarketing = false
      if (valueFromChild.confirm == 'decline') {
        this.handleLoading(false)
        this.modalcondition.notification = {
          email: false,
          sms: false,
          line: false,
        }
        this.checkMarketing = []
        document.getElementById('marketing_message').checked = false
        this.consentparams.marketing = this.MarketingMessage.Version * -1
      } else if (valueFromChild.confirm == 'agree') {
        if (this.checkDataNoti(valueFromChild.notification)) {
          this.modalcondition.notification = valueFromChild.notification
          this.handleLoading(false)
          this.checkMarketing.push('marketing_message')
          document.getElementById('marketing_message').checked = true
          this.consentparams.marketing = this.MarketingMessage.Version
        } else {
          this.modalcondition.notification = {
            email: false,
            sms: false,
            line: false,
          }
          this.handleLoading(false)
          this.checkMarketing = []
          document.getElementById('marketing_message').checked = false
          this.consentparams.marketing = this.MarketingMessage.Version * -1
        }
      }

      if (this.isRequiredMarketing && this.checkMarketing.length === 0) {
        this.isErrorMarketing = true
      }
    },
    checkDataNoti(notification) {
      if (
        notification.email != false ||
        notification.sms != false ||
        notification.line != false
      ) {
        return true
      } else {
        return false
      }
    },
    setCacheCustom() {
      var registerstore = {
        name: this.name,
        lastname: this.lastname,
        mobilenumber: this.mobilenumber,
        email: this.email,
        radioGender: this.radioGender,
        selected_local: this.selected_local,
        ReferenceInfo: this.ReferenceInfo,
        ReferenceInfo2: this.ReferenceInfo2,
        citizen_id: this.citizen_id,
        selected_day: this.selected_day,
        selected_month: this.selected_month,
        selected_year: this.selected_year,
      }
      Account.setCacheCustom(
        'RegisterStore_' + Account.getCacheCustom('app_id'),
        registerstore,
      )
    },
    toTimestamp(strDate) {
      var datum = Date.parse(strDate)
      return datum / 1000
    },
    clicknext() {
      this.handleLoading(true)
      console.log('clicknext')
      this.isSentOtpEmail = false
      if (this.checkForm()) {
        if (this.isFromSigleSignOn) {
          if (this.loginTypeList.includes('Device')) {
            this.registerSingleSignOn().then(() => {
              if (this.$route.query.refusercode) {
                this.fgfModalHandler(true)
              } else {
                this.success()
              }
              this.handleLoading(false)
            })
          } else {
            this.registerSingleSignOn().then(result => {
              if (
                this.$route.query.skip_register &&
                !this.loginTypeList.includes('Line') &&
                !this.loginTypeList.includes('Device')
              ) {
                if (
                  this.$route.query.useOTP &&
                  !Vue.bzbsConfig.businessRule.webFor.PH
                ) {
                  var userInfo = Account.getCacheCustom(
                    'RegisterStore_' + Account.getCacheCustom('app_id'),
                  )
                    ? Account.getCacheCustom(
                        'RegisterStore_' + Account.getCacheCustom('app_id'),
                      )
                    : null

                  this.otp_params_email.contact_number = userInfo
                    ? userInfo.mobilenumber
                    : null
                  this.otp_params_email.app_id = Account.getCacheCustom(
                    'BzbsUser_' + Account.getCacheCustom('app_id'),
                  ).appId
                  this.otp_params_email.channel = 'register'
                  this.otp_params_email.isRegsiter = true
                  this.otp_params_email.name = userInfo ? userInfo.name : null
                  this.otp_params_email.email = userInfo ? userInfo.email : null
                  this.otp_params_email.userId =
                    Account.getCacheCustomByAppId('userId')
                  this.isSentOtpEmail = true
                } else {
                  this.postRegister()
                }
              } else {
                if (
                  !this.loginTypeList.includes('Line') &&
                  !this.loginTypeList.includes('Device')
                ) {
                  if (result) {
                    this.loginFacebook()
                  }
                }
              }
            })
          }
        } else {
          this.registerprofile(null).then(() => {
            this.callApiConcent().then(() => {
              if (this.$route.query.refusercode) {
                this.fgfModalHandler(true)
              } else {
                this.success()
              }
              this.handleLoading(false)
            })
          })
        }
      } else {
        this.handleLoading(false)
        console.log(' Not pass')
        if (this.windowWidth >= 600 && this.windowHeight >= 600) {
          this.isshowalert = false
        } else {
          this.isshowalert = true
        }
      }
    },
    lineLogin(token) {
      var params = {
        app_id: Account.getCacheCustom('app_id'),
        id_token: this.$route.query.id_token,
      }
      BzbsAuth.apilineotpdirectlogin(params, token)
        .then(response_line => {
          this.handleLoading(false)
          console.log('response_line ::', response_line)
          // Account.setCacheUser(response_line.data)
          Account.setCacheToken(response_line.data.token)
          Account.setCacheWalletToken(response_line.data.ewallet_token)
          if (this.$route.query.refusercode) {
            this.fgfModalHandler(true)
          } else {
            this.success()
          }
        })
        .catch(error => {
          this.handleLoading(false)
          if (!_.isEmpty(error.response.data.error)) {
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: error.response.data.error.message,
            }
          }
          if (
            _.isEmpty(error.response) ||
            _.isEmpty(error.response.data.error)
          ) {
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: this.lbl.error.connectionproblem,
            }
          }
        })
    },
    ChangeOTP(event) {
      this.isSuccessOTP = false

      if (event.is_register == true) {
        this.eventOtp = event

        this.postRegister()
      }
    },
    postRegister() {
      this.handleLoading(true)

      var userInfo = Account.getCacheCustom(
        'RegisterStore_' + Account.getCacheCustom('app_id'),
      )
        ? Account.getCacheCustom(
            'RegisterStore_' + Account.getCacheCustom('app_id'),
          )
        : null

      var monthNumber = this.pad(
        this.lbl.date.month_full.indexOf(this.selected_month) + 1,
      )
      var date_Birth = this.pad(this.selected_day)
      var date_str =
        this.selected_year + '-' + monthNumber + '-' + date_Birth + ' 12:00:00'
      var arr = date_str.split(/[- :]/)
      var date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5])
      var BirthDate = this.toTimestamp(date)
      let params = {}

      var verify1 = userInfo ? userInfo.verifyCode1 : ''
      var verify2 = userInfo ? userInfo.verifyCode2 : ''
      var verify3 = userInfo ? userInfo.verifyCode3 : ''

      let email = 0
      if (this.modalcondition.notification.email) {
        email = 1
      } else {
        email = 0
      }
      let sms = 0
      if (this.modalcondition.notification.sms) {
        sms = 1
      } else {
        sms = 0
      }
      let line = 0
      if (this.modalcondition.notification.line) {
        line = 1
      } else {
        line = 0
      }
      if (this.$route.query.useOTP && !Vue.bzbsConfig.businessRule.webFor.PH) {
        let custom_info = {
          registered: true,
          reference_info: this.$route.query.verifyCode1,
          reference_info2: this.$route.query.verifyCode2,
        }

        if (this.$route.query.verifyCode1) {
          custom_info.verifyCode1 = this.$route.query.verifyCode1
        }
        if (this.$route.query.verifyCode2) {
          custom_info.verifyCode2 = this.$route.query.verifyCode2
        }
        if (this.$route.query.verifyCode3) {
          custom_info.verifyCode3 = this.$route.query.verifyCode3
        }
        params = {
          username: verify1,
          password: verify2,
          confirmpassword: verify2,
          app_id: Account.getCacheCustom(
            'BzbsUser_' + Account.getCacheCustom('app_id'),
          ).appId,
          firstname: userInfo ? userInfo.name : null,
          lastname: userInfo ? userInfo.lastname : null,
          email: userInfo ? userInfo.email : null,
          contact_number: userInfo ? userInfo.mobilenumber : null,
          gender: userInfo ? userInfo.radioGender : null,
          birthdate: BirthDate,
          idcard: this.citizen_id ? this.citizen_id : null,
          custom_info: custom_info,
          otp: this.eventOtp.params.otp,
          refcode: this.eventOtp.params.refcode,
        }
      } else {
        params = {
          username: verify1,
          password: verify2,
          confirmpassword: verify2,
          app_id: Account.getCacheCustom(
            'BzbsUser_' + Account.getCacheCustom('app_id'),
          ).appId,
          firstname: userInfo ? userInfo.name : null,
          lastname: userInfo ? userInfo.lastname : null,
          email: userInfo ? userInfo.email : null,
          contact_number: userInfo ? userInfo.mobilenumber : null,
          gender: userInfo ? userInfo.radioGender : null,
          birthdate: BirthDate,
          dataprivacy: this.consentparams.dataprivacy,
          consentAge: this.consentAge,
          termandcondition: this.consentparams.termandcondition,
          marketingOption: this.consentparams.marketingOption,
          mktoption_email: email,
          mktoption_sms: sms,
          mktoption_line: line,
          custom_info: {
            verifyCode1: verify1,
            verifyCode2: verify2,
            verifyCode3: verify3,
          },
        }
      }
      return new Promise(resolve => {
        BzbsLogin.postRegister(params)
          .then(res => {
            console.log('postRegister', res)
            this.loginEmail()
            resolve(res.data)
          })
          .catch(error => {
            this.handleLoading(false)
            if (this.storeinfo.UseOTP) {
              if (
                error.response.data.error.message ==
                'This username has already been taken.'
              ) {
                this.showError = true
                this.dataError = {
                  title: this.lbl.error.errortitle,
                  detail: this.lbl.error.this_email_has_already_been_taken,
                }
              } else if (
                error.response.data.error.code == 403 ||
                error.response.data.error.code == 409 ||
                error.response.data.error.id == 2078
              ) {
                this.showError = true
                this.dataError = {
                  title: this.lbl.error.errortitle,
                  detail: error.response.data.error.message,
                }
              } else {
                this.isSuccessOTP = true
                this.dataOTP = {
                  id: error.response.data.error.id,
                  message: error.response.data.error.message,
                }
              }
            } else {
              if (
                error.response.data.error.message ==
                'This username has already been taken.'
              ) {
                this.showError = true
                this.dataError = {
                  title: this.lbl.error.errortitle,
                  detail: this.lbl.error.this_email_has_already_been_taken,
                }
              } else {
                this.showError = true
                this.dataError = {
                  title: this.lbl.error.errortitle,
                  detail: error.response.data.error.message,
                }
              }
            }
            console.log('postRegister error', error)
            resolve(error)
          })
      })
    },
    loginEmail() {
      this.handleLoading(true)

      var userInfo = Account.getCacheCustom(
        'RegisterStore_' + Account.getCacheCustom('app_id'),
      )
        ? Account.getCacheCustom(
            'RegisterStore_' + Account.getCacheCustom('app_id'),
          )
        : null

      let params = {
        username: userInfo ? userInfo.verifyCode1 : '',
        password: userInfo ? userInfo.verifyCode2 : '',
        app_id: this.AppId,
      }

      return new Promise(resolve => {
        BzbsLogin.apiBzbsLogin(params)
          .then(response => {
            this.handleLoading(false)
            Account.setCacheUser(response.data)
            Account.setCacheToken(response.data.token)
            Account.setCacheWalletToken(response.data.ewallet_token)
            Account.apiGetProfile()
            var storInfoParam = {}
            Account.actioncrmpluscustomer(storInfoParam, response.data.token)
              .then(crmpluscustomer => {
                console.log(crmpluscustomer)
                Account.setCacheCustomByAppId(
                  'UserLevel',
                  response.data.userLevel,
                )
                this.callApiConcent().then(() => {
                  if (this.$route.query.refusercode) {
                    this.fgfModalHandler(true)
                  } else {
                    this.success()
                  }
                })
              })
              .catch(error => {
                console.log(error)
                this.handleLoading(false)
                this.showError = true
                this.dataError = {
                  title: this.lbl.error.errortitle,
                  detail:
                    error.response.data.error.message ||
                    this.lbl.error.connectionproblem,
                }
              })

            resolve(response.data)
          })
          .catch(error => {
            console.log(error)
            this.handleLoading(false)
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail:
                error.response.data.error.message ||
                this.lbl.error.connectionproblem,
            }
            resolve(error)
          })
      })
    },

    loginFacebook() {
      let params = {
        access_token: this.$route.query.id_token,
      }
      return new Promise(resolve => {
        BzbsLogin.apiBzbsFacebookLogin(params)
          .then(response => {
            Account.setCacheUser(response.data)
            Account.setCacheToken(response.data.token)
            Account.setCacheWalletToken(response.data.ewallet_token)
            this.callApiConcent().then(() => {
              this.callapiMarketing().then(() => {
                if (this.$route.query.refusercode) {
                  this.fgfModalHandler(true)
                } else {
                  this.success()
                }
                this.handleLoading(false)
              })
            })
            resolve(response.data)
          })
          .catch(error => {
            console.log(error)
            this.handleLoading(false)
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail:
                error.response.data.error.message ||
                this.lbl.error.connectionproblem,
            }

            resolve(error)
          })
      })
    },

    registerSingleSignOn() {
      return new Promise(resolve => {
        var userInfo = Account.getCacheCustom(
          'RegisterStore_' + Account.getCacheCustom('app_id'),
        )
          ? Account.getCacheCustom(
              'RegisterStore_' + Account.getCacheCustom('app_id'),
            )
          : null
        if (this.$route.query.single_signon && this.$route.query.id_token) {
          if (this.$route.query.useOTP) {
            this.consentData = null
            var newDate = new Date()
            var toDay = this.toTimestamp(newDate)
            this.objProfileInfo = {
              strFirstName: this.cus_compusr
                ? this.cus_compusr.data.FirstName
                : null,
              strLastName: this.cus_compusr
                ? this.cus_compusr.data.LastName
                : null,
              strBirthDate: this.cus_compusr
                ? this.cus_compusr.data.BirthDate
                : null,
              strContactNumber: this.cus_compusr
                ? this.cus_compusr.data.Tel
                : null,
              strEmail: this.cus_compusr ? this.cus_compusr.data.Email : null,
              strGender: this.cus_compusr ? this.cus_compusr.data.Gender : null,
              struserId: Account.getCacheCustomByAppId('userId'),
              struserAppId: Account.getCacheCustom('app_id'),
              strVerifyCode1: this.$route.query.verifyCode1,
              strVerifyCode2: this.$route.query.verifyCode2,
              strVerifyCode3: this.$route.query.verifyCode3,
              strRefCode: null,
              strExpireInSeconds: null,
              strjoinDate: toDay,
            }
            let email = 0
            if (this.modalcondition.notification.email) {
              email = 1
            } else {
              email = 0
            }
            let sms = 0
            if (this.modalcondition.notification.sms) {
              sms = 1
            } else {
              sms = 0
            }
            let line = 0
            if (this.modalcondition.notification.line) {
              line = 1
            } else {
              line = 0
            }
            this.consentData = {
              dataprivacy: this.consentparams.dataprivacy,
              termandcondition: this.consentparams.termandcondition,
              marketingOption: this.consentparams.marketing,
              consentAge: this.consentAge,
              email: email,
              sms: sms,
              line: line,
            }
            this.otp_params.contact_number = this.cus_compusr
              ? this.cus_compusr.data.Tel
              : null
            this.otp_params.app_id = Account.getCacheCustom('app_id')
            this.otp_params.channel = 'register'
            this.otp_params.isRegsiter = true
            this.isSentOtp = true
          } else {
            this.handleLoading(true)
            var strExtendJson = {}
            if (
              this.storeinfo.IsCompany ||
              this.storeinfo.CompanyVerifyWithOtp
            ) {
              strExtendJson.verifiedConpanyUser = true
            }
            if (
              !_.isEmpty(this.ReferenceInfo) &&
              !_.isEmpty(this.ReferenceInfo2)
            ) {
              strExtendJson.registered = true
              strExtendJson.reference_info = this.ReferenceInfo
              strExtendJson.reference_info2 = this.ReferenceInfo2
            } else if (
              !_.isEmpty(this.ReferenceInfo) &&
              _.isEmpty(this.ReferenceInfo2)
            ) {
              strExtendJson.registered = true
              strExtendJson.reference_info = this.ReferenceInfo
              strExtendJson.reference_info2 = ''
            } else if (
              _.isEmpty(this.ReferenceInfo) &&
              !_.isEmpty(this.ReferenceInfo2)
            ) {
              strExtendJson.registered = true
              strExtendJson.reference_info = ''
              strExtendJson.reference_info2 = this.ReferenceInfo2
            } else {
              strExtendJson.registered = true
              strExtendJson.reference_info = ''
              strExtendJson.reference_info2 = ''
            }
            let params = {}

            var monthNumber = this.pad(
              this.lbl.date.month_full.indexOf(this.selected_month) + 1,
            )
            var date_Birth = this.pad(this.selected_day)
            var date_str =
              this.selected_year +
              '-' +
              monthNumber +
              '-' +
              date_Birth +
              ' 12:00:00'
            var arr = date_str.split(/[- :]/)
            var date = new Date(
              arr[0],
              arr[1] - 1,
              arr[2],
              arr[3],
              arr[4],
              arr[5],
            )
            var BirthDate = this.toTimestamp(date)

            var tokenType = this.loginType.toLowerCase().includes('facebook')
              ? 'facebook'
              : this.loginType.toLowerCase().includes('line')
              ? 'line'
              : this.loginType.toLowerCase().includes('email')
              ? 'email'
              : 'line'

            let email = 0
            if (this.modalcondition.notification.email) {
              email = 1
            } else {
              email = 0
            }
            let sms = 0
            if (this.modalcondition.notification.sms) {
              sms = 1
            } else {
              sms = 0
            }
            let line = 0
            if (this.modalcondition.notification.line) {
              line = 1
            } else {
              line = 0
            }

            let custom_info = {}
            if (
              this.$route.query.verifyCode1 != undefined &&
              this.$route.query.verifyCode2 != undefined &&
              this.$route.query.verifyCode3 != undefined &&
              this.$route.query.verifyCode1 != null &&
              this.$route.query.verifyCode2 != null &&
              this.$route.query.verifyCode3 != null
            ) {
              custom_info = {
                verifyCode1: this.$route.query.verifyCode1,
                verifyCode2: this.$route.query.verifyCode2,
                verifyCode3: this.$route.query.verifyCode3,
              }
            } else if (
              this.$route.query.verifyCode1 != undefined &&
              this.$route.query.verifyCode2 != undefined &&
              this.$route.query.verifyCode1 != null &&
              this.$route.query.verifyCode2 != null
            ) {
              custom_info = {
                verifyCode1: this.$route.query.verifyCode1,
                verifyCode2: this.$route.query.verifyCode2,
                verifyCode3: null,
              }
            } else if (
              this.$route.query.verifyCode1 != undefined &&
              this.$route.query.verifyCode1 != null
            ) {
              custom_info = {
                verifyCode1: this.$route.query.verifyCode1,
                verifyCode2: null,
                verifyCode3: null,
              }
            }

            params = {
              id_token: this.$route.query.id_token,
              app_id: Account.getCacheCustom('app_id'),
              tokenType: tokenType,
              os: 'web',
              firstname: userInfo ? userInfo.name : null,
              lastname: userInfo ? userInfo.lastname : null,
              gender: userInfo ? userInfo.gender : null,
              contact_number: userInfo ? userInfo.mobilenumber : null,
              birthdate: BirthDate,
              idcard: this.citizen_id ? this.citizen_id : null,
              extendjsonstring: strExtendJson,
              termandcondition: this.consentparams.termandcondition,
              dataprivacy: this.consentparams.dataprivacy,
              consentemail: email,
              consentsms: sms,
              consentline: line,
              consentAge: this.consentAge,
              marketingOption: this.consentparams.marketing,
              custom_info: custom_info,
            }
            if (
              !this.loginTypeList.includes('Line') &&
              this.loginTypeList.includes('Device')
            ) {
              params.tokenType = 'device'
              params.contact_number = this.$route.query.mobile
              params.otp = this.$route.query.otp
              params.refcode = this.$route.query.refcode
            } else if (
              this.loginTypeList.includes('Line') &&
              this.loginTypeList.includes('Device')
            ) {
              params.tokenType = 'line'
              params.contact_number = this.$route.query.mobile
              params.otp = this.$route.query.otp
              params.refcode = this.$route.query.refcode
              params.uuid = this.$route.query.id_token
            }

            if (this.$route.query.refusercode) {
              params.refusercode = this.$route.query.refusercode
            }

            var refcode = this.$route.query.refcode
              ? this.$route.query.refcode
              : null
            var otp = this.$route.query.otp ? this.$route.query.otp : null
            BzbsProfile.RegisterSingleSignOn(params, refcode, otp)
              .then(res => {
                this.handleLoading(false)

                if (res.data.success) {
                  // Account.setCacheUser(res.data.data)
                  Account.setCacheToken(res.data.data.token)
                  Account.setCacheWalletToken(res.data.data.ewallet_token)

                  if (this.loginTypeList.includes('Line')) {
                    var param = {
                      app_id: Account.getCacheCustom('app_id'),
                      id_token: params.id_token,
                    }
                    Account.actionLineDirectLogin(param, true)
                      .then(response_line => {
                        console.log('response_line ::', response_line)
                        Account.setCacheUser(response_line.data)
                        Account.setCacheToken(response_line.data.token)
                        Account.setCacheWalletToken(
                          response_line.data.ewallet_token,
                        )
                        if (
                          this.$route.query.single_signon &&
                          this.$route.query.id_token &&
                          this.$route.query.skip_register
                        ) {
                          if (this.$route.query.refusercode) {
                            this.fgfModalHandler(true)
                          } else {
                            this.success()
                          }
                        }

                        resolve(true)
                      })
                      .catch(error => {
                        this.handleLoading(false)
                        if (_.isEmpty(error.response)) {
                          this.handleLoading(false)
                          this.showError = true
                          this.dataError = {
                            title: this.lbl.error.errortitle,
                            detail: this.lbl.error.connectionproblem,
                          }
                        }
                        if (this.isDebug) {
                          alert(
                            'Register Profile Error => ' +
                              JSON.stringify(error.response),
                          )
                        }
                        if (
                          error.response.data.error.message ==
                            'DuplicateEmail' &&
                          error.response.data.error.id == 2089
                        ) {
                          this.showError = true
                          this.dataError = {
                            title: this.lbl.error.errortitle,
                            detail: this.lbl.error.emailregistered,
                          }
                        } else if (error.response.data.error.id == 2078) {
                          this.isphoneerror = true
                          this.showError = true
                          this.dataError = {
                            title: this.lbl.error.errortitle,
                            detail: this.lbl.error.contactnumberregistered,
                          }
                        } else {
                          this.showError = true
                          this.dataError = {
                            title: this.lbl.error.errortitle,
                            detail: error.response.data.error.message,
                          }
                        }
                        resolve(false)
                      })
                  } else {
                    let data = {
                      sponsorId: this.sponsorId,
                      appId: this.AppId,
                      channel: 'device',
                    }
                    Account.setCacheUser(data)
                    if (this.loginTypeList.includes('Device')) {
                      if (this.$route.query.refusercode) {
                        this.fgfModalHandler(true)
                      } else {
                        this.success()
                      }
                    } else {
                      this.loginFacebook()
                    }
                  }
                } else {
                  this.showError = true
                  this.dataError = {
                    title: this.lbl.error.errortitle,
                    detail: res.data.message,
                  }
                }
              })
              .catch(error => {
                this.handleLoading(false)
                console.log('registerSingleSignOn error ::', error)
                if (_.isEmpty(error.response)) {
                  this.handleLoading(false)
                  this.showError = true
                  this.dataError = {
                    title: this.lbl.error.errortitle,
                    detail: this.lbl.error.connectionproblem,
                  }
                }
                if (this.isDebug) {
                  alert(
                    'Register Profile Error => ' +
                      JSON.stringify(error.response),
                  )
                }
                if (error.response.status === 401) {
                  this.dataError = {
                    title: this.lbl.error.errortitle,
                    detail: error.response.data.error.message,
                  }
                  if (this.loginTypeList.includes('Device')) {
                    window.location = window.location.origin + '/landing/email'
                  }
                  if (this.loginTypeList.includes('Line')) {
                    var fullPath = Account.getCacheCustomByAppId('fullPath')
                    if (fullPath) {
                      window.location = window.location.origin + fullPath
                    } else {
                      this.showError = true
                    }
                  }
                }

                if (
                  error.response.data.error.message == 'DuplicateEmail' &&
                  error.response.data.error.id == 2089
                ) {
                  this.showError = true
                  this.dataError = {
                    title: this.lbl.error.errortitle,
                    detail: this.lbl.error.emailregistered,
                  }
                } else if (error.response.data.error.id == 2078) {
                  this.isphoneerror = true
                  this.showError = true
                  this.dataError = {
                    title: this.lbl.error.errortitle,
                    detail: this.lbl.error.contactnumberregistered,
                  }
                } else {
                  this.handleLoading(false)
                  this.showError = true
                  this.dataError = {
                    title: this.lbl.error.errortitle,
                    detail: error.response.data.error.message,
                  }
                }
                resolve(false)
              })
          }
        } else {
          resolve(true)
        }
      })
    },
    fgfModalHandler(value, isGoTo = false) {
      this.isFGFmodal = value
      if (isGoTo) {
        window.location = '/home'
      }
    },
    registerprofile(value) {
      return new Promise((resolve, reject) => {
        var strExtendJson = {}
        var newDate = new Date()
        var toDay = this.toTimestamp(newDate)
        if (this.storeinfo.IsCompany || this.storeinfo.CompanyVerifyWithOtp) {
          strExtendJson.verifiedConpanyUser = true
          strExtendJson.verifyCode1 = this.$route.query.verifyCode1
        }
        if (!_.isEmpty(this.ReferenceInfo) && !_.isEmpty(this.ReferenceInfo2)) {
          strExtendJson.registered = true
          strExtendJson.reference_info = this.ReferenceInfo
          strExtendJson.reference_info2 = this.ReferenceInfo2
        } else if (
          !_.isEmpty(this.ReferenceInfo) &&
          _.isEmpty(this.ReferenceInfo2)
        ) {
          strExtendJson.registered = true
          strExtendJson.reference_info = this.ReferenceInfo
          strExtendJson.reference_info2 = ''
        } else if (
          _.isEmpty(this.ReferenceInfo) &&
          !_.isEmpty(this.ReferenceInfo2)
        ) {
          strExtendJson.registered = true
          strExtendJson.reference_info = ''
          strExtendJson.reference_info2 = this.ReferenceInfo2
        } else {
          strExtendJson.registered = true
          strExtendJson.reference_info = ''
          strExtendJson.reference_info2 = ''
        }

        this.objProfileInfo.strjoinDate = toDay

        if (value && value.successotp) {
          this.objProfileInfo.otp = value.strOTP
        }
        if (value && value.refcode) {
          this.objProfileInfo.refcode = value.refcode
        }
        this.objProfileInfo.struserId = Account.getCache(
          'BzbsUser_' + Account.getCacheCustom('app_id'),
        ).userId

        BzbsProfile.RegisterProfile(
          Account.getCacheToken() ? Account.getCacheToken() : null,
          this.objProfileInfo,
          null,
          strExtendJson,
          null,
          null,
        )
          .then(Response => {
            console.log('updated :: ' + JSON.stringify(Response))
            if (
              !this.storeinfo.IsSkipRegister &&
              this.storeinfo.IsCompany &&
              this.$route.query.verifyCode1 &&
              this.$route.query.verifyCode2
            ) {
              this.callAPIcompanyuser()
            }
            setTimeout(() => {
              resolve(true)
            }, 1000)
          })
          .catch(error => {
            this.handleLoading(false)
            if (_.isEmpty(error.response)) {
              this.handleLoading(false)
              this.showError = true
              this.dataError = {
                title: this.lbl.error.errortitle,
                detail: this.lbl.error.connectionproblem,
              }
            }
            if (
              error.response.data.error.message == 'DuplicateEmail' &&
              error.response.data.error.id == 2089
            ) {
              this.showError = true
              this.dataError = {
                title: this.lbl.error.errortitle,
                detail: this.lbl.error.emailregistered,
              }
            } else if (error.response.data.error.id == 2078) {
              this.isphoneerror = true
              this.showError = true
              this.dataError = {
                title: this.lbl.error.errortitle,
                detail: this.lbl.error.contactnumberregistered,
              }
            } else {
              this.showError = true
              this.dataError = {
                title: this.lbl.error.errortitle,
                detail: error.response.data.error.message,
              }
            }
            reject()
          })
      })
    },
    callAPIcompanyuser() {
      var isusecompany = this.storeinfo.IsCompany
      if (!isusecompany) return

      var params = {
        verifyCode1: this.$route.query.verifyCode1,
        verifyCode2: this.$route.query.verifyCode2,
      }
      this.handleLoading(true)
      BzbsCompanycrm.apicompanyuser(params)
        .then(data => {
          console.log(data)
          this.handleLoading(false)
        })
        .catch(() => {
          this.isshowalert = true
          this.handleLoading(false)
          this.errors = []
          this.errors.push({
            name: this.lbl.companycrm.popuperror.name,
            action: this.lbl.companycrm.unauthtext.name,
          })
        })
    },
    getUserConnections() {
      var savedRegisterConnections = this.$store.state.savedRegisterConnections
      if (savedRegisterConnections) {
        this.RegisterStoreConnections = savedRegisterConnections
      } else {
        this.$store.commit(
          'savedRegisterConnections',
          this.RegisterStoreConnections,
        )
      }
    },
    getprofileinit() {
      this.handleLoading(true)
      return new Promise(resolve => {
        BzbsProfile.getProfile(
          Account.getCacheToken() ? Account.getCacheToken() : null,
        )
          .then(res => {
            this.checkCondition = []
            if (res.data.DataPrivacy > 0 && res.data.TermAndCondition > 0) {
              this.checkCondition.push('consentPDPA')
            } else {
              this.checkCondition = []
            }
            this.handleLoading(false)
            resolve(res.data)
          })
          .catch(error => {
            console.log(error)
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: error.response.data.error.message,
            }
            this.handleLoading(false)
            resolve(error)
          })
      })
    },
    getCustomerStore() {
      this.handleLoading(true)

      return new Promise(resolve => {
        BzbsDashboard.getCustomerStore()
          .then(res => {
            this.genInfo(res)
            this.handleLoading(false)
            resolve(res.data)
          })
          .catch(error => {
            if (_.isEmpty(error.response)) {
              this.handleLoading(false)
              this.showError = true
              this.dataError = {
                title: this.lbl.error.errortitle,
                detail: this.lbl.error.connectionproblem,
              }
            }
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail:
                error.response.data.error.message ||
                this.lbl.error.connectionproblem,
            }
            this.handleLoading(false)
            resolve(error)
          })
      })
    },
    genInfo(res) {
      this.storeinfo.image_header = encodeURI(res.data.StoreDetail.CoverUrl)
      this.storeinfo.image_logo = encodeURI(res.data.StoreDetail.LogoUrl)
      this.storeinfo.businessName = res.data.StoreDetail.BusinessName
      this.storeinfo.buttoncolor = res.data.StoreDetail.ButtonColor
      this.storeinfo.buttontextcolor = res.data.StoreDetail.ButtonTextColor
      this.storeinfo.UseOTP = res.data.UseOTP
      this.storeinfo.IsSkipRegister = res.data.StoreDetail.IsSkipRegister
      this.storeinfo.IsCompany = res.data.StoreDetail.IsCompany
      this.loginType = res.data.StoreDetail.LoginType
      this.sponsorId = res.data.StoreDetail.PartitionKey
      this.arrList(this.loginType)
      this.modalcondition.storeinfo = this.storeinfo
      this.TermAndCondition = res.data.TermAndCondition
      this.PrivacyPolicy = res.data.PrivacyPolicy
      this.MarketingMessage = res.data.MarketingMessage
      this.IsCompany = res.data.StoreDetail.IsCompany
      this.directBrandAUrl = res.data.StoreDetail.DirectBrandA
      this.isBrandA = res.data.IsBrandA

      this.isDisplayTermandPrivacy =
        res.data.StoreDetail.DisplayTermAndCondition
      this.isDisplayAgeCondition = res.data.StoreDetail.DisplayConsentAge
      this.isDisplayMarketing = res.data.StoreDetail.DisplayMarketingMessage
      this.isRequiredTermandPrivacy =
        res.data.StoreDetail.RequireTermAndCondition
      this.isRequiredAgeCondition = res.data.StoreDetail.RequireConsentAge
      this.isRequiredMarketing = res.data.StoreDetail.RequireMarketingMessage
      this.consentAge = res.data.StoreDetail.ConsentAge
        ? res.data.StoreDetail.ConsentAge
        : 15
      this.TermAndConditionEN = res.data.StoreDetail.TermAndConditionEN
      this.TermAndConditionTH = res.data.StoreDetail.TermAndConditionTH
      this.PrivacyMessageEN = res.data.StoreDetail.PrivacyMessageEN
      this.PrivacyMessageTH = res.data.StoreDetail.PrivacyMessageTH
      this.MarketingMessageEN = res.data.StoreDetail.MarketingMessageEN
      this.MarketingMessageTH = res.data.StoreDetail.MarketingMessageTH
      this.isUseSingleUserAccount = res.data.UseSingleUserAccount

      // For handle not display = not required
      if (!this.isDisplayTermandPrivacy) this.isRequiredTermandPrivacy = false
      if (!this.isDisplayAgeCondition) this.isRequiredAgeCondition = false
      if (!this.isDisplayMarketing) this.isRequiredMarketing = false

      this.isReferenceRequired = res.data.StoreDetail.ReferenceRequiredField
      this.isReference = res.data.StoreDetail.IsReference
      if (this.isJsonString(res.data.StoreDetail.ReferenceCustomName)) {
        let parse = JSON.parse(res.data.StoreDetail.ReferenceCustomName)
        this.ReferenceCustomName = parse
      } else {
        this.isReference = true
        this.ReferenceCustomName = {}
      }
      this.isReferenceRequired2 = res.data.StoreDetail.ReferenceRequiredField2
      this.isReference2 = res.data.StoreDetail.IsReference2
      if (this.isJsonString(res.data.StoreDetail.ReferenceCustomName2)) {
        let parse = JSON.parse(res.data.StoreDetail.ReferenceCustomName2)
        this.ReferenceCustomName2 = parse
      } else {
        this.isReference2 = true
        this.ReferenceCustomName2 = {}
      }
    },
    arrList(string) {
      var list = string.split(',')
      this.loginTypeList = list
      return list
    },
    isJsonString(str) {
      try {
        JSON.parse(str)
      } catch (e) {
        return false
      }
      return true
    },

    dateofbird() {
      return new Promise((resolve, reject) => {
        try {
          this.selected_day = this.lbl.account.birth.day
          this.selected_month = this.lbl.account.birth.month
          this.selected_year = this.lbl.account.birth.year
          var current_date = new Date()
          this.month = this.lbl.date.month_full
          this.year = this.getYearBirth()
          this.day = this.getDaysInMonth(
            current_date.getUTCMonth() + 1,
            current_date.getUTCFullYear(),
          )

          setTimeout(() => {
            if (
              Account.getCacheCustom(
                'catchdate_' + Account.getCacheCustom('app_id'),
              )
            ) {
              if (
                Account.getCacheCustom(
                  'catchdate_' + Account.getCacheCustom('app_id'),
                ).date != null
              ) {
                this.selected_day = Account.getCacheCustom(
                  'catchdate_' + Account.getCacheCustom('app_id'),
                ).date
              }
              if (
                Account.getCacheCustom(
                  'catchdate_' + Account.getCacheCustom('app_id'),
                ).month != null
              ) {
                var montharray = this.lbl.date.month_full_arr
                var month_number = Account.getCacheCustom(
                  'catchdate_' + Account.getCacheCustom('app_id'),
                ).month
                this.selected_month = montharray[month_number - 1].strtext
              }
              if (
                Account.getCacheCustom(
                  'catchdate_' + Account.getCacheCustom('app_id'),
                ).year != null
              ) {
                this.selected_year = Account.getCacheCustom(
                  'catchdate_' + Account.getCacheCustom('app_id'),
                ).year
              }
            }
          }, 1000)
          resolve(this.day)
        } catch (error) {
          reject(error)
        }
      })
    },
    getYearBirth() {
      var year_list_start = new Date().getFullYear()
      var year_list_end = year_list_start - 100
      var year_options = []
      for (var y = year_list_start; y >= year_list_end; y--) {
        year_options.push(y)
      }
      return year_options
    },
    getDaysInMonth(month, year) {
      return new Date(year, month, 0).getDate()
    },
    onDateChange(event) {
      console.log(event.target.value)
      this.catchdate.date = event.target.value

      this.setcatchdatefun(this.catchdate.date, null, null)
    },
    onMonthChange(event) {
      var current_date = new Date()
      var year_selected = !this.selected_year
        ? this.selected_year
        : current_date.getUTCFullYear()
      var month_selected =
        this.lbl.date.month_full.indexOf(this.selected_month) + 1
      this.day = this.getDaysInMonth(month_selected, year_selected)
      console.log(event.target.value)
      this.catchdate.month = month_selected
      this.setcatchdatefun(null, this.catchdate.month, null)
    },
    onYearChange(event) {
      var current_date = new Date()
      var year_selected = !_.isEmpty(this.selected_year)
        ? this.selected_year
        : current_date.getUTCFullYear()
      console.log(event)
      var month_selected =
        this.lbl.date.month_full.indexOf(this.selected_month) + 1
      this.day = this.getDaysInMonth(month_selected, year_selected)
      this.catchdate.year = event.target.value
      this.setcatchdatefun(null, null, this.catchdate.year)
    },
    setcatchdatefun(date, month, year) {
      this.catchdate.date =
        date != null
          ? date
          : Account.getCacheCustom(
              'catchdate_' + Account.getCacheCustom('app_id'),
            ) != null
          ? Account.getCacheCustom(
              'catchdate_' + Account.getCacheCustom('app_id'),
            ).date
          : null
      this.catchdate.month =
        month != null
          ? month
          : Account.getCacheCustom(
              'catchdate_' + Account.getCacheCustom('app_id'),
            ) != null
          ? Account.getCacheCustom(
              'catchdate_' + Account.getCacheCustom('app_id'),
            ).month
          : null
      this.catchdate.year =
        year != null
          ? year
          : Account.getCacheCustom(
              'catchdate_' + Account.getCacheCustom('app_id'),
            ) != null
          ? Account.getCacheCustom(
              'catchdate_' + Account.getCacheCustom('app_id'),
            ).year
          : null
      console.log(
        'catchdate_' + Account.getCacheCustom('app_id'),
        this.catchdate,
      )
      Account.setCacheCustom(
        'catchdate_' + Account.getCacheCustom('app_id'),
        this.catchdate,
      )
    },
    checkForm: function () {
      this.isphoneerror = false
      this.isErrorUnderYears = false
      this.isErrorCondition = false
      this.isErrorMarketing = false

      var checkAgeCondition = false

      if (this.isRequiredAgeCondition && !this.checkUnderYears) {
        this.isErrorUnderYears = true
      }

      if (this.isRequiredTermandPrivacy && this.checkCondition.length <= 0) {
        this.isErrorCondition = true
      }

      if (this.isRequiredAgeCondition && this.checkUnderYears) {
        checkAgeCondition = true
      }
      if (!this.isRequiredAgeCondition) {
        checkAgeCondition = true
      }

      if (this.isRequiredMarketing && this.checkMarketing.length <= 0) {
        this.isErrorMarketing = true
      }

      if (checkAgeCondition && !this.isErrorCondition && !this.isErrorMarketing)
        return true
      else this.haserrors = true
    },
    getMarketing(e) {
      e.preventDefault()
      return new Promise(resolve => {
        this.Folder = 'CRMPlus'

        var shortLocal = Account.getCacheCustom('BzbsLocale')
        var lang_code = shortLocal.toUpperCase() == 'TH' ? 'TH' : 'EN'
        if (lang_code == 'EN') {
          this.modalcondition.marketingpathpdf =
            this.MarketingMessage.SecondaryLanguageConsentUrl
        } else {
          this.modalcondition.marketingpathpdf =
            this.MarketingMessage.PrimaryLanguageConsentUrl
        }
        this.isMarketing = true
        resolve(true)
      })
    },
    getTerms() {
      return new Promise(resolve => {
        this.Folder = 'CRMPlus'
        var shortLocal = Account.getCacheCustom('BzbsLocale')
        var lang_code = shortLocal.toUpperCase() == 'TH' ? 'TH' : 'EN'
        if (lang_code == 'EN') {
          this.modalcondition.termspathpdf =
            this.TermAndCondition.SecondaryLanguageConsentUrl
        } else {
          this.modalcondition.termspathpdf =
            this.TermAndCondition.PrimaryLanguageConsentUrl
        }
        resolve(true)
      })
    },
    getPrivacy() {
      return new Promise(resolve => {
        if (!this.IsCompany && !this.Cuscompusr) {
          this.Folder = 'defaultcrmplus'
        }
        var shortLocal = Account.getCacheCustom('BzbsLocale')
        var lang_code = shortLocal.toUpperCase() == 'TH' ? 'TH' : 'EN'
        if (lang_code == 'EN') {
          this.modalcondition.privacypathpdf =
            this.PrivacyPolicy.SecondaryLanguageConsentUrl
        } else {
          this.modalcondition.privacypathpdf =
            this.PrivacyPolicy.PrimaryLanguageConsentUrl
        }
        resolve(true)
      })
    },
    getPDPA() {
      Promise.all([this.getTerms(), this.getPrivacy()])
        .then(() => {
          this.isPDPA = true
          this.modalcondition.ismodalShow = true
        })
        .catch(error => {
          this.showError = true
          if (!_.isEmpty(error.response.data.error)) {
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: error.response.data.error.message,
            }
          }
          if (
            _.isEmpty(error.response) ||
            _.isEmpty(error.response.data.error)
          ) {
            this.handleLoading(false)
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: this.lbl.error.error_upload_term_and_condition,
            }
          }
        })
    },
    callApiConcent() {
      this.handleLoading(true)

      return new Promise((resolve, reject) => {
        let email = 0
        if (this.modalcondition.notification.email) {
          email = 1
        } else {
          email = 0
        }
        let sms = 0
        if (this.modalcondition.notification.sms) {
          sms = 1
        } else {
          sms = 0
        }
        let line = 0
        if (this.modalcondition.notification.line) {
          line = 1
        } else {
          line = 0
        }

        let param = {
          termandcondition: this.consentparams.termandcondition,
          dataprivacy: this.consentparams.dataprivacy,
          email: email,
          sms: sms,
          line: line,
          consentAge: this.consentAge,
          marketingOption: this.consentparams.marketing,
        }
        let token = Account.getCacheToken() ? Account.getCacheToken() : null
        BzbsAuth.actionPostConsent(param, token)
          .then(() => {
            resolve(true)
          })
          .catch(error => {
            if (_.isEmpty(error.response)) {
              this.handleLoading(false)
              this.showError = true
              this.dataError = {
                title: this.lbl.error.errortitle,
                detail: this.lbl.error.connectionproblem,
              }
            }
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: error.response.data.error.message,
            }
            reject(error)
          })
      })
    },
    handleClickLinkPDPA(e, isTermFirst = true) {
      e.preventDefault()
      this.isTermFirst = isTermFirst
      this.getPDPA()
    },
    ChangeErrorMarketing(event) {
      this.isMarketing = event
    },
    ChangeErrorSettingMarketing(event) {
      this.isSettingMarketing = event
      this.checkMarketing = []
      document.getElementById('marketing_message').checked = false
      this.consentparams.marketing = this.MarketingMessage.Version * -1
    },
    ChangeCloseOtp(event) {
      this.isSentOtp = event.value
      if (event.error) {
        this.showError = true
        this.dataError = {
          title: this.lbl.error.errortitle,
          detail: event.error,
        }
      }
    },
    ChangeError(event) {
      this.showError = event
    },
    ChangeAlertError(value) {
      this.isshowalert = value
      this.isshowalertyear = value
    },
    success() {
      this.handleLoading(false)
      this.isRegisterSuccess = true
      setTimeout(() => this.setAttributeModal(), 500)
    },
    verifyOTPSuccess() {
      this.handleLoading(false)
      console.log('verify OTP Auto Register Success :: ')
      if (this.$route.query.refusercode) {
        this.fgfModalHandler(true)
      } else {
        this.success()
      }
    },
    registerSuccess() {
      if (this.isBrandA && this.IsCompany && this.directBrandAUrl) {
        var token = Account.getCacheToken() ? Account.getCacheToken() : null
        var directUrl = this.directBrandAUrl
        if (directUrl.includes('?')) {
          directUrl =
            directUrl +
            '&token=' +
            token +
            '&app_id=' +
            Account.getCacheCustom('app_id')
        } else {
          directUrl =
            directUrl +
            '?token=' +
            token +
            '&app_id=' +
            Account.getCacheCustom('app_id')
        }
        window.open(encodeURI(directUrl), '_self')
      } else {
        if (this.$route.query.target_page != undefined) {
          var target_page = this.$route.query.target_page
            ? this.$route.query.target_page
            : null
          if (target_page == 'ecomurl') {
            var url = ''
            if (this.redirectUrl) {
              url =
                this.redirectUrl +
                '?token=' +
                Account.getCacheToken() +
                '&app_id=' +
                Account.getCacheCustom('app_id')
              window.open(encodeURI(url), '_self')
            } else {
              window.location =
                '/' +
                target_page +
                '?app_id=' +
                Account.getCacheCustom(
                  'BzbsUser_' + Account.getCacheCustom('app_id'),
                ).appId
            }
          } else {
            window.location =
              '/' +
              target_page +
              '?app_id=' +
              Account.getCacheCustom(
                'BzbsUser_' + Account.getCacheCustom('app_id'),
              ).appId
          }
        } else {
          window.location =
            '/home?app_id=' +
            Account.getCacheCustom(
              'BzbsUser_' + Account.getCacheCustom('app_id'),
            ).appId
        }
      }
    },
    setAttributeModal() {
      document
        .getElementsByClassName('ant-modal-confirm-title')[0]
        .setAttribute('crm_at', 'title_success')
      document
        .getElementsByClassName('ant-btn ant-btn-primary')[0]
        .setAttribute('crm_at', 'btn_success')
    },
    gotoBack() {
      console.log('gotoBack', this.$route)
      if (this.$route.query.goback == 'companycrm') {
        window.location = '/companycrm'
      } else {
        window.location = '/selectpage'
      }
    },
    validateInput(value) {
      const maxLength = 13

      if (value.length !== maxLength) {
        return true
      } else if (
        value !== undefined &&
        value.length === maxLength &&
        this.validNationalID(value)
      ) {
        return false
      } else if (
        value !== undefined &&
        value.length === maxLength &&
        !this.validNationalID(value)
      ) {
        return true
      }
    },
    validNationalID(id) {
      if (id == null || id.length !== 13) return false
      let i
      let sum = 0
      for (i = 0, sum = 0; i < 12; i++) {
        sum += parseInt(id.charAt(i)) * (13 - i)
      }
      const mod = sum % 11
      const check = (11 - mod) % 10
      if (check === parseInt(id.charAt(12))) {
        return true
      }
      return false
    },
    pad(d) {
      return d < 10 ? '0' + d.toString() : d.toString()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/_mixin.scss';

.term-and-condition-wrapper {
  height: 100vh;
  padding: 16px;
  font-size: 14px;
  color: #757575;
  display: flex;
  flex-direction: column;

  .welcome-wrapper {
    flex: 9;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    color: #666;

    .welcome-image {
      width: 108px;
      height: 108px;
      border-radius: 1000px;
      border: solid 1px #fff;
      margin-bottom: 16px;
    }
  }
  .body-wrapper {
    margin-bottom: 44px;
    .check-box-wrapper {
      margin-bottom: 36px;
      .icheck-primary {
        display: flex;
        gap: 8px;
        align-items: center;
      }
      .icheck-primary > input:first-child:checked + label::before {
        background-color: $color-radio-check;
        border-color: $color-radio-check;
      }
    }
    .next-button {
      width: 100%;
      align-items: center;
      padding: 16px 24px;
      border-radius: 100px;
      font-size: 16px;
      opacity: 1;
    }
    .disable {
      opacity: 0.5;
    }
  }
  @include breakpoint-min($tablet-xs) {
    position: absolute;
    max-width: 1024px;
    top: 0;
    z-index: 1;
    width: 65%;
    height: 80%;
    border-radius: 10px;
    margin: auto;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #ffffff;
  }
}
.cover-image {
  height: 100vh;
  width: 100vw;
  background-repeat: round;
  background-size: cover;
}
</style>
